<template>
  <div id="my">
      <!-- 头像和用户名 -->
      <section class="top">
          <img :src="profile" alt="">
          <h5>{{this.nickName }}</h5>
      </section>
      <!-- 菜单 -->
      <section class="menuFour">
          <ul>
              <li class="per"><router-link to="/personInfo"  >个人信息<span><img  class="right2" src="/static/img/rightArr.png"></span></router-link></li>
              <li class="pay"><router-link to="/payList">缴费记录<span><img  class="right2" src="/static/img/rightArr.png"></span></router-link></li>
              <!--<li class="serReport"><router-link to="/complainList">服务记录<span><img class="right2" src="/static/img/rightArr.png"></span></router-link></li>-->
              <li class="serReport"><router-link to="/BxComplain"  >报修记录<span><img  class="right2" src="/static/img/rightArr.png"></span></router-link></li>
              <li class="serReport-advise"><router-link to="/complainListQingMeng">投诉建议记录<span><img  class="right2" src="/static/img/rightArr.png"></span></router-link></li>
              <li class="home-inspection-application" v-if="hideBeiDaPage"><router-link to="/homeInspectionApplication">验房记录<span><img class="right2" src="/static/img/rightArr.png"></span></router-link></li>
              <li class="decorate-to-apply-for" v-if="hideBeiDaPage"><router-link to="/decorationList">装修记录<span><img class="right2" src="/static/img/rightArr.png"></span></router-link></li>
          </ul>
      </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
      profile: '',
      nickName : '',
      hideBeiDaPage:true
    }
  },
  created(){
    if(sessionStorage.getItem('action') === 'homePageBeiDaZiYuan' || sessionStorage.getItem('home')==='homePageBeiDaZiYuan' || sessionStorage.getItem('action') === 'checkTelBeiDaZiYuan' || sessionStorage.getItem('home') === 'checkTelBeiDaZiYuan' ||sessionStorage.getItem('action') === 'homePageWanTong' || sessionStorage.getItem('home')==='homePageWanTong' ||sessionStorage.getItem('action') === 'homePageXinYuan' || sessionStorage.getItem('home')==='homePageXinYuan')
    this.hideBeiDaPage = false ;
  },
  mounted () {
    let vm = this
  	//初始化服务记录页面显示
    sessionStorage.setItem('tousu','0')
    vm.userlist()
  },
  methods: {
    userlist () {
      const _this = this
      _this.postRequest('user/currentUserDetail ', {},function (data) {
        _this.nickName  = data.nickName
        _this.profile = data.profilePhoto
        sessionStorage.setItem('nickName ', data.nickName)
        sessionStorage.setItem('profile', data.profilePhoto)
        sessionStorage.setItem('phone', data.phone)
        sessionStorage.setItem('id', data.id)
      })
    }
  }
}
</script>
<style scoped>
.right2{
    width: 12px;
    height: 21px;
}
#my{
    width: 100%;
    height: 100%;
    background-color: #eee;
}
#my .top{
    height: 236px;
    margin-bottom: 18px;
    background-color: #fff;
}
#my .top img{
    float: left;
    margin-left: 46px;
    margin-top: 53px;
    width: 148px;
    height: 148px;
    border-radius: 74px;
}

#my .top h5{
    float: left;
    color: #333;
    margin-left: 20px;
    margin-top: 105px;
    font-size: 40px;
    font-weight: 400;
}
#my .menuFour{
    background-color: #fff;
}
 #my .menuFour ul{
      width: 100%;
      box-sizing: border-box;
      padding: 35px 31px 0 31px;
 }
#my .menuFour ul li{
      line-height: 100px;
      box-sizing: border-box;
      border-bottom: 1px solid #f5f5f5;
  }
#my .menuFour ul li a{
    display: inline-block;
    text-align: left;
    width: 100%;
    height: 100%;
    line-height: 4;
    font-size:32px;
    margin-left: 22px;
    box-sizing: border-box;
}
#my .menuFour ul li a span{
    font-size: 30px;
    float: right;
    color:#DAD8D8;
    margin-right: 20px;
}
/*个人信息选项*/
#my .menuFour ul .per a{
    background: url(/static/img/per2.png)no-repeat;
    background-position: 0px 50px;
    background-size: 30px 30px;
    padding-left: 55px;
}
/*缴费记录选项*/
#my .menuFour ul .pay a{
    background: url(/static/img/pay2.png)no-repeat;
    background-position: 0px 50px;
    background-size: 30px 30px;
  padding-left: 55px;
}
/*服务记录选项*/
#my .menuFour ul .serReport a{
    background: url(/static/img/serReport.png)no-repeat;
    background-position: 0px 50px;
    background-size: 30px 30px;
  padding-left: 55px;
}
/*投诉建议*/
#my .menuFour ul .serReport-advise a{
  background: url('../../../static/img/advise-xinYuan.png') no-repeat;
  background-position: 0px 50px;
  background-size: 30px 30px;
  padding-left: 55px;
}
/*验房记录*/
#my .menuFour ul .home-inspection-application a{
  background: url(/static/img/home-inspection-application.png)no-repeat;
  background-position: 0px 50px;
  background-size: 30px 30px;
  padding-left: 55px;
}
/*验房记录*/
#my .menuFour ul .decorate-to-apply-for a{
  background: url(/static/img/decorate-to-apply-for.png)no-repeat;
  background-position: 0px 50px;
  background-size: 30px 30px;
  padding-left: 55px;
}
/*#my .menuFour ul li a {
	  background-position: 0px 35px;
    background-size: 20px 20px;
}*/
/*#my .menuFour ul .hisOrder a{
    background: url(/static/img/hisOrder.png)no-repeat;
    background-position: 0px 35px;
    background-size: 30px 30px;
}*/
#my .menuFour ul .address a{
    background: url(/static/img/address.png)no-repeat;
    background-position: 0px 35px;
    background-size: 30px 30px;
}
#my .menuFour input{
    width: 690px;
    height: 90px;
    font-size: 30px;
    color: #fff;
    border-radius: 45px;
    background-color: #1B82D1;
    margin-top: 198px;
    margin-bottom: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/xinyuan/my-xinyuan.vue